import { createApi } from '@reduxjs/toolkit/query/react';
import { API_INVENTORY_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';
import { CityApi, CitiesFilter } from '../models';
import { PaginatedRequest, PaginatedResponse } from '@/types';

const cityService = createApi({
  reducerPath: 'cityService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/cities`),
  tagTypes: ['Cities'],
  endpoints: (builder) => ({
    getCities: builder.query<
      PaginatedResponse<CityApi>,
      { filters?: CitiesFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => ({
        url: '',
        params: {
          ...(filters || {}),
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        },
      }),
      providesTags: ['Cities'],
    }),
    createCity: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Cities'],
    }),
    updateCity: builder.mutation({
      query: ({ id, body }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Cities'],
    }),
  }),
});

export default cityService;
export const {
  useGetCitiesQuery,
  useCreateCityMutation,
  useUpdateCityMutation,
} = cityService;
